var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33236 10.3818H1V7.04944L4.33236 3.71532H7.66559H10.9988V5.38238H27.6659L31 7.04944V8.71649V17.05L27.6659 18.7153V25.3818L26.111 20.3824H24.3335L22.6665 25.3818V20.3824H14.3329L12.6659 25.3818V20.3824H10.9988L9.33353 25.3818V18.7153H7.66647L4.33236 15.383V10.3818Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66559 3.71532H10.9988V5.38238H27.6659L31 7.04944V8.71649V17.05L27.6659 18.7153V25.3818L26.111 20.3824H24.3335L22.6665 25.3818V20.3824H14.3329L12.6659 25.3818V20.3824H10.9988L9.33353 25.3818V18.7153H7.66647L4.33236 15.383V10.3818H1V7.04944L4.33236 3.71532H7.66559ZM7.66559 3.71532L10.9988 1",
    stroke: "#0C2128",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSmall);
export default __webpack_public_path__ + "static/media/iconSmall.723f7b08c5b4fdfbec84ee53de3b11ea.svg";
export { ForwardRef as ReactComponent };